import React from 'react'
import { WithdrawalGroupList } from './list/page'
export const WithdrawalGroupsPage = () => {
  return <WithdrawalGroupList />
}
